import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 5.4a.6.6 0 0 1 .6.6v10.552l4.976-4.976a.6.6 0 0 1 .848.848l-6 6a.6.6 0 0 1-.848 0l-6-6a.6.6 0 0 1 .848-.848l4.976 4.976V6a.6.6 0 0 1 .6-.6Z"
      clip-rule="evenodd"
    />
  </svg>
`;
